function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $c680ae9f6e787033$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"9sXZ0":"index.8daad9c8.js","bYDTK":"users.bca4f848.jpg","cDRUh":"index.ca00257f.css"}'));


var $c72e52cb0914bfb9$exports = {};

$c72e52cb0914bfb9$exports = new URL((parcelRequire("27Lyk")).resolve("bYDTK"), import.meta.url).toString();


const $761f97bf09d51d3e$var$about = document.getElementById("about");
const $761f97bf09d51d3e$var$app = document.querySelector(".app");
const $761f97bf09d51d3e$var$dropShadow = document.querySelector(".dropShadow");
const $761f97bf09d51d3e$var$experience = document.getElementById("experience");
const $761f97bf09d51d3e$var$footer = document.getElementById("footer");
const $761f97bf09d51d3e$var$nav = document.querySelector(".header-nav");
const $761f97bf09d51d3e$var$navItem = document.querySelectorAll(".navItem");
// const project = document.getElementById('project');
const $761f97bf09d51d3e$var$welcomeImage = document.querySelector(".welcomeImage");
const $761f97bf09d51d3e$var$userImage = document.querySelector(".header-profile--userImage");
const $761f97bf09d51d3e$var$totalFrames = 600;
let $761f97bf09d51d3e$var$length, $761f97bf09d51d3e$var$path;
let $761f97bf09d51d3e$var$currentFrame = 0;
let $761f97bf09d51d3e$var$handle = 0;
//changing dropshadow based on mouse position
(()=>{
    $761f97bf09d51d3e$var$app.addEventListener("mousemove", (e)=>{
        const cursorPosition = `600px at ${e.pageX}px ${e.pageY}px`;
        $761f97bf09d51d3e$var$dropShadow.style.background = `radial-gradient(
      ${cursorPosition},
      rgba(29, 78, 216, 0.15),
      transparent 80%
    )`;
    });
})();
//maniputaling active class of nav items on click and implementing smooth scrolling
(()=>{
    $761f97bf09d51d3e$var$nav.addEventListener("click", (e)=>{
        e.preventDefault();
        const closesetNavItem = e.target.closest(".navItem");
        if (closesetNavItem) {
            const id = closesetNavItem.getAttribute("href");
            $761f97bf09d51d3e$var$navItem.forEach((item)=>item.classList.remove("active"));
            closesetNavItem.classList.add("active");
            const headerOffset = id === "#about" ? 200 : 80;
            const elementPosition = document.querySelector(id).getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    });
})();
//draw animation for welcome svg
const $761f97bf09d51d3e$var$draw = ()=>{
    const progress = $761f97bf09d51d3e$var$currentFrame / $761f97bf09d51d3e$var$totalFrames;
    if (progress > 0.25) {
        $761f97bf09d51d3e$var$path.style.strokeDashoffset = "7156";
        $761f97bf09d51d3e$var$path.style.fill = "rgb(226 232 240)";
        window.cancelAnimationFrame($761f97bf09d51d3e$var$handle);
    } else {
        $761f97bf09d51d3e$var$currentFrame++;
        $761f97bf09d51d3e$var$path.style.strokeDashoffset = Math.floor($761f97bf09d51d3e$var$length * (1 - [
            progress
        ]));
        $761f97bf09d51d3e$var$handle = window.requestAnimationFrame($761f97bf09d51d3e$var$draw);
    }
};
//initialising welcome svg animations and userprofle src
(()=>{
    if ($761f97bf09d51d3e$var$userImage) $761f97bf09d51d3e$var$userImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($c72e52cb0914bfb9$exports)));
    $761f97bf09d51d3e$var$welcomeImage?.addEventListener("load", ()=>{
        const doc = $761f97bf09d51d3e$var$welcomeImage?.contentDocument;
        $761f97bf09d51d3e$var$path = doc?.getElementById("welcome_path");
        if ($761f97bf09d51d3e$var$path) {
            $761f97bf09d51d3e$var$length = $761f97bf09d51d3e$var$path.getTotalLength();
            $761f97bf09d51d3e$var$path.style.stroke = "rgb(226 232 240)";
            $761f97bf09d51d3e$var$path.style.strokeDasharray = $761f97bf09d51d3e$var$length + " " + $761f97bf09d51d3e$var$length;
            $761f97bf09d51d3e$var$path.style.fill = "rgb(15 23 42)";
            $761f97bf09d51d3e$var$draw();
        }
    });
})();
/* intersection observer callback function to active nav 
 item depending on viewport visiblity of particular item */ const $761f97bf09d51d3e$var$callback = (entries)=>{
    entries.forEach((entry)=>{
        const { target: target, isIntersecting: isIntersecting } = entry;
        const element = document.querySelector(`.navItem-${target.id}`);
        if (isIntersecting) {
            console.log("inside isintersecting", $761f97bf09d51d3e$var$navItem, element);
            $761f97bf09d51d3e$var$navItem.forEach((el)=>el.classList.remove("active"));
            element?.classList.add("active");
        }
    });
};
// intersection observer api to change nav item on scroll
(()=>{
    let options = {
        root: null,
        threshold: [
            0.6
        ],
        rootMargin: "0%"
    };
    let observer = new IntersectionObserver($761f97bf09d51d3e$var$callback, options);
    observer.observe($761f97bf09d51d3e$var$about);
    observer.observe($761f97bf09d51d3e$var$experience);
    // observer.observe(project);
    observer.observe($761f97bf09d51d3e$var$footer);
})();


//# sourceMappingURL=index.8daad9c8.js.map
